import { getPageSEO } from 'helpers/seo'
import { withAuth } from 'hocs/withAuth'
import { withAuthServerSideProps } from 'hocs/withAuth/withAuthServerSideProps'

import dynamic from 'next/dynamic'

const SalariesPage = dynamic(() =>
  import('containers/SalariesPage').then((res) => res.SalariesPage)
)

export default withAuth(SalariesPage, {
  LoggedOutComponent: SalariesPage,
})
export const getServerSideProps = withAuthServerSideProps(() =>
  getPageSEO('salaries')
)
